export function isOverflowing(el, axis) {
    let isOverflowing = false;
    let currentOverflow = el.style.overflow;

    if (!currentOverflow || currentOverflow === "visible") {
        el.style.overflow = "hidden";
    }

    switch (axis) {
        case 'x':
            isOverflowing = el.clientWidth < el.scrollWidth;
            break;
        case 'y':
            isOverflowing = el.clientHeight < el.scrollHeight;
            break;
        default:
            isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    }

    el.style.overflow = currentOverflow;

    return isOverflowing;
}